export default __webpack_public_path__ + "static/media/pantry2-after2-1440w.00d8fdb8.webp";